<template>
  <section>
    <p class="gp-section-title">
      <span>{{ position }}</span
      >Klebstoffe
    </p>

    <div class="g-pb-10" v-if="description">
      <p class="gea-two-column-description">
        {{ description }}
      </p>
    </div>

    <div class="gp-2-column">
      <div class="gp-left-column">
        <!-- <section-content :title="mainTitle" :body="body"></section-content> -->
        <option-list :options="options" :title="optionsTitle" module="untergrund" @select="optionSelected"></option-list>

        <div class="g-flex g-items-center g-mt-8">
          <gp-icon
            :icon="['fas', 'info-circle']"
            class="g-text-green-500"
            :style="{
              transform: 'scale(1.3)',
            }"
          />
          <p class="g-ml-2 g-font-bold g-text-lg">Tipp</p>
        </div>
        <p class="gea-two-column-description">
          {{ texts["5.1"] }}
        </p>
      </div>

      <div class="gp-right-column">
        <big-option-list
          v-slot="{ option }"
          module="untergrund"
          stateKey="secondarySelection"
          :options="secondaryOptions"
          :title="optionsTitle"
          @select="selectSecondaryOption"
        >
          <p>Verbrauch*</p>
          <p class="g-font-bold g-text-xl">{{ calculateRecomendedAmount(option) }} liter</p>
          <p class="g-text-sm g-text-gray-500">*es handelt sich hierbei um einen Richtwert</p>
        </big-option-list>
      </div>
    </div>
  </section>
</template>

<script>
import BigOptionList from "../components/BigOptionList.vue";
import OptionList from "../components/OptionList.vue";
import SectionContent from "../components/SectionContent.vue";
export default {
  components: { SectionContent, OptionList, BigOptionList },
  name: "Untergrund",

  async created() {
    await this.$store.dispatch("untergrund/fetchOptions");
    this.$store.dispatch("untergrund/selectOption", this.options[0]);
    this.$store.dispatch("untergrund/selectSecondaryOption", this.selection?.options[0]); // Reset glue selection when changing options
    this.$store.dispatch("untergrund/selectSecondaryOption", this.options[0].options[0]);
    this.$store.dispatch("zusammenstellung/fetchItemsAllItemsForModule", { module: "untergrund", store: this.$store });
  },

  data() {
    return {};
  },

  computed: {
    mainTitle() {
      return "Der passende Kleber";
    },

    optionsTitle() {
      return "Aus welchem Material besteht der Untergrund?";
    },

    texts() {
      return this.$store.state.inhalt.texts;
    },

    body() {
      return "Condimentum dapibus urna sodales elit dignissim sociosqu nunc finibus dictum fusce adipiscing taciti felis sed a magna vulputate lectus inceptos, malesuada volutpat platea lobortis praesent per lacinia senectus.";
    },

    options() {
      return this.$store.state.untergrund.options;
    },

    secondaryOptions() {
      let options = this.$store.state.untergrund.selection.options;
      if (!options) return [];

      return options.filter((option) => {
        return option.name !== "";
      });
    },

    roofAreaWithoutSideAdditions() {
      let abmessungen = this.$store.state.abmessungen;
      return Number(abmessungen.width) * Number(abmessungen.depth);
    },

    additionalRoofArea() {
      let abmessungen = this.$store.state.abmessungen;
      let fullRoofArea =
        (Number(abmessungen.width) + Number(abmessungen.addedWidth) / 100) *
        (Number(abmessungen.depth) + Number(abmessungen.addedDepth) / 100);

      return fullRoofArea - this.roofAreaWithoutSideAdditions;
    },

    randfixierung() {
      return this.$store.state.dachnutzung?.selection.randfixierung;
    },
  },

  methods: {
    optionSelected(option) {
      this.$store.dispatch("untergrund/selectOption", option);
      this.$store.dispatch("untergrund/selectSecondaryOption", option.options[0]);
    },

    selectSecondaryOption(option) {
      this.$store.dispatch("untergrund/selectSecondaryOption", option);
    },

    calculateRecomendedAmount(option) {
      let area = Number(this.roofAreaWithoutSideAdditions * option.factor);

      // If the chosen dachnutzung recommends only randfixierung, then use only half of the base area
      if (this.randfixierung) area = area / 2;

      // Always include area for addtions (dachrand), since these are always supposed to be glued
      area = area + Number(this.additionalRoofArea * option.factor);

      return area.toFixed(2).replace(".", ",");
    },
  },

  watch: {},

  props: ["position", "description"],
};
</script>

<style></style>
